import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {
  getColumnKey,
  Icon, ProgressBarComponent,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import { isNotNil } from '@web/utils';
import { AdminBackgroundTaskCollectionItem } from '../../models/admin-background-task-collection-item';
import { AdminBackgroundTaskCollectionFilter } from '../../models/admin-background-task-collection-filter';
import { AdminBackgroundTaskStatusComponent } from '../admin-background-task-status/admin-background-task-status.component';
import { AdminBackgroundTaskTypeComponent } from '../admin-background-task-type/admin-background-task-type.component';

@Component({
  selector: 'app-admin-background-task-list-custom-cell-template',
  imports: [
    TableBodyNoReferenceCellComponent,
    AdminBackgroundTaskStatusComponent,
    AdminBackgroundTaskTypeComponent,
    ProgressBarComponent,
  ],
  templateUrl: './admin-background-task-list-custom-cell-template.component.html',
  styleUrl: './admin-background-task-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminBackgroundTaskListCustomCellTemplateComponent {
  /* prettier-ignore */
  public readonly column = input.required<TableColumn<AdminBackgroundTaskCollectionItem, AdminBackgroundTaskCollectionFilter>>();
  /* prettier-ignore */
  public readonly model = input.required<AdminBackgroundTaskCollectionItem>();

  /* prettier-ignore */
  protected readonly getColumnKey = getColumnKey<AdminBackgroundTaskCollectionItem>;
  protected readonly isNotNil = isNotNil;
  protected readonly Icon = Icon;
}
